import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var UrlSvg = function UrlSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6356F6",
    d: "M20.333 2H3.667C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m9.51 11.592.145.005a.417.417 0 0 1-.048.832 2.07 2.07 0 0 0-1.488.514l-.092.086-1.25 1.25a2.082 2.082 0 0 0 2.856 3.03l.09-.085 1.25-1.25c.416-.416.635-.99.601-1.579a.416.416 0 1 1 .832-.048 2.9 2.9 0 0 1-.743 2.11l-.1.106-1.25 1.25a2.917 2.917 0 0 1-4.219-4.025l.094-.098 1.25-1.25a2.9 2.9 0 0 1 2.071-.848M15.21 8.79c.149.148.162.38.04.543l-.04.046-5.833 5.832a.417.417 0 0 1-.63-.543l.041-.046 5.833-5.832a.417.417 0 0 1 .59 0m1.294-3.357a2.916 2.916 0 0 1 1.401 4.78l-.093.098-1.25 1.25a2.9 2.9 0 0 1-2.217.842.417.417 0 1 1 .048-.831 2.07 2.07 0 0 0 1.488-.515l.091-.086 1.25-1.25a2.082 2.082 0 0 0-2.856-3.03l-.09.086-1.25 1.248a2.07 2.07 0 0 0-.598 1.58.417.417 0 0 1-.832.048 2.9 2.9 0 0 1 .74-2.11l.1-.106 1.25-1.25a2.92 2.92 0 0 1 2.818-.754",
    clipRule: "evenodd"
  }));
};
export var Url = function Url(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: UrlSvg
  }));
};